import { useDataTypesHooks } from "../../../../../features/data-types"
import { Modal, ModalId, useUIActions } from "../../../../../features/ui"
import { HoardOrder } from "../../../state/types"

type Props = {
    hoard: HoardOrder
    extendedValue?: number
    pendingPayment?: number
    // Acopio en cuenta corriente: lo que se amplía (con el recargo del acopio) y el crédito disponible del cliente
    isCreditAccount?: boolean
    addedAmount?: number
    availableCredit?: number
    onSubmit: () => void
    onCollectNow?: () => void
}

export const ExtendHoardValueModal = (props: Props) => {
    const { hoard, extendedValue = 0, pendingPayment = 0, isCreditAccount, addedAmount = 0, availableCredit, onSubmit, onCollectNow } = props

    const { formatPrice } = useDataTypesHooks()
    const { closeModal } = useUIActions()

    // Sin límite de crédito configurado no se bloquea la carga a cuenta corriente
    const exceedsCredit = !!isCreditAccount && availableCredit !== undefined && addedAmount > availableCredit

    const valueChange = <>
        Los productos seleccionados superan el crédito pendiente del acopio. El valor del acopio pasará
        de <b>{formatPrice(hoard.value!)}</b> a <b>{formatPrice(extendedValue)}</b>
    </>

    const handleCollectNow = () => {
        closeModal(ModalId.EXTEND_HOARD_VALUE)
        onCollectNow?.()
    }

    if (!isCreditAccount) {
        return (
            <Modal
                modalId={ModalId.EXTEND_HOARD_VALUE}
                title="Ampliar valor del acopio?"
                submitLabel="Confirmar y Emitir"
                widthSize="m"
                onSubmit={onSubmit}
            >
                <p>{valueChange} y quedará un saldo pendiente de pago de <b>{formatPrice(pendingPayment)}</b>.</p>
                <p>El acopio no admitirá nuevas entregas. Desea confirmar la entrega?</p>
            </Modal>
        )
    }

    // Si el excedente supera el crédito disponible, no se puede cargar a la cuenta corriente: solo se puede cobrar ahora
    return exceedsCredit ? (
        <Modal
            modalId={ModalId.EXTEND_HOARD_VALUE}
            title="Sin crédito disponible"
            submitLabel="Cobrar Ahora"
            widthSize="m"
            onSubmit={onCollectNow}
        >
            <p>{valueChange}.</p>
            <p>
                El excedente de <b>{formatPrice(addedAmount)}</b> supera el crédito disponible en la cuenta corriente del
                cliente (<b>{formatPrice(availableCredit!)}</b>), así que no se puede cargar a la cuenta corriente.
            </p>
            <p>Para emitir la entrega hay que cobrar ahora el excedente. La entrega se emite al confirmar el cobro.</p>
        </Modal>
    ) : (
        <Modal
            modalId={ModalId.EXTEND_HOARD_VALUE}
            title="Ampliar valor del acopio?"
            submitLabel="Cargar a Cuenta Corriente"
            widthSize="m"
            onSubmit={onSubmit}
            secondaryLabel="Cobrar Ahora"
            onSecondarySubmit={handleCollectNow}
        >
            <p>{valueChange}.</p>
            <p>
                El excedente de <b>{formatPrice(addedAmount)}</b> se puede cargar a la cuenta corriente del cliente
                {availableCredit !== undefined && <> (crédito disponible: <b>{formatPrice(availableCredit)}</b>)</>} o
                cobrar ahora. El acopio no admitirá nuevas entregas.
            </p>
        </Modal>
    )
}
